import * as React from 'react';
import { useEffect, useState, useMemo } from 'react';
import BentoBox from '../BentoBox';
import { BentoBox as BentoBoxType } from 'types/generated';
import { fetchBentoBoxes } from '@/clients/BentoBoxUtils';
import { PlaceholderBox } from './PlaceHolderBox';

interface BentoBoxItem {
  sys: {
    id: string;
  };
}

interface BentoBoxId {
  data: {
    items: BentoBoxItem[];
  };
}

const LayoutFive = ({ data }: BentoBoxId) => {
  const bentoBoxIds = useMemo(() => data?.items?.slice(0, 2).map((item: BentoBoxItem) => item?.sys?.id) || [], [data]);

  const [bentoBoxes, setBentoBoxes] = useState<BentoBoxType[]>([]);

  useEffect(() => {
    const fetchBox = async () => {
      if (bentoBoxIds.length) {
        const fetchedBoxes = await fetchBentoBoxes(bentoBoxIds);
        if (fetchedBoxes) {
          setBentoBoxes(fetchedBoxes);
        }
      }
    };
    fetchBox();
  }, [bentoBoxIds]);

  if (bentoBoxes.length < 2) {
    return (
      <>
        {/* Mobile: show only the first BentoBox */}
        <div className="block min-h-[70vh] w-full md:hidden">
          <PlaceholderBox />
        </div>

        {/* Desktop: side-by-side layout */}
        <div className="hidden min-h-[70vh] w-full md:flex">
          <div className="w-3/5">
            <PlaceholderBox />
          </div>
          <div className="mx-16 w-2/5">
            <PlaceholderBox />
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      {/* Mobile: show only the first BentoBox */}
      <div className="block min-h-[70vh] w-full md:hidden">
        <BentoBox box={bentoBoxes[0]} />
      </div>

      {/* Desktop: side-by-side layout */}
      <div className="hidden min-h-[70vh] w-full md:flex">
        <div className="w-3/5">
          <BentoBox box={bentoBoxes[0]} />
        </div>
        <div className="mx-16 w-2/5">
          <BentoBox box={bentoBoxes[1]} />
        </div>
      </div>
    </>
  );
};

export default LayoutFive;
